import React from "react";
import { Dropdown } from "primereact/dropdown";
import { useIntl } from "react-intl";
import { UserConfigData } from "../../../../dto/profiledata/ProfileDataFormDTO";
import { ComboDataDTO } from "../../../../dto/ComboDataDTO";
import { EInputTypes, InputTextCustom } from "medere-ui-framework";

interface UserConfigTabProps {
    userConfigData:UserConfigData
    setConfigData: (userConfigData: UserConfigData) => void;
    /** Establecimientos elegibles como predeterminado; con menos de 2 el campo no se muestra. */
    buildingOptions: ComboDataDTO[];
    /** Mensaje del backend cuando el establecimiento elegido dejó de estar disponible. */
    defaultBuildingError?: string;
    errors?: {
        username?: boolean;
        password?: boolean;
        confirmpassword?: boolean;
    };
}

export default function UserConfigTab({userConfigData, setConfigData, buildingOptions, defaultBuildingError, errors}:UserConfigTabProps) {
    const intl = useIntl();

    return <React.Fragment>
        <div className="config-container">
            <fieldset className="password-section">
                <h3 className="password-title">Contraseña</h3> 
                <div className="input-group">
                    <div className="input-item input-user">
                        <label style={{marginLeft: '10px'}}>Usuario</label>
                        <InputTextCustom
                            inputType={EInputTypes.TEXT}
                            value={userConfigData?.username}
                            error={errors?.username}
                            onChange={(e: any) => {setConfigData({ ...userConfigData, username: e.target.value });
                            }}
                            className="input-field input-large" 
                        />
                    </div>
                    <div className="input-item input-password">
                        <label style={{marginLeft: '10px'}}>Contraseña</label>
                        <InputTextCustom
                            inputType={EInputTypes.PASSWORD}
                            value={userConfigData?.password}
                            error={errors?.password}
                            onChange={(e: any) => {setConfigData({ ...userConfigData, password: e.target.value });
                            }}
                            className="input-field input-medium"
                        />
                    </div>
                    <div className="input-item input-password">
                        <label style={{marginLeft: '10px'}}>Confirmar contraseña</label>
                        <InputTextCustom
                            inputType={EInputTypes.PASSWORD}
                            value={userConfigData?.confirmpassword}
                            error={errors?.confirmpassword}
                            onChange={(e: any) => {setConfigData({ ...userConfigData, confirmpassword: e.target.value });
                            }}
                            className="input-field input-medium"
                        />
                    </div>
                </div>
            </fieldset>
            {buildingOptions.length > 1 && (
                <fieldset className="password-section default-building-section">
                    <h3 className="password-title">{intl.formatMessage({ id: 'DefaultBuilding' })}</h3>
                    <div className="input-item default-building-item">
                        <Dropdown
                            inputId="defaultbuilding"
                            ariaLabel={intl.formatMessage({ id: 'DefaultBuilding' })}
                            value={userConfigData?.defaultbuilding?.id ?? null}
                            options={buildingOptions}
                            optionLabel="name"
                            optionValue="id"
                            showClear
                            filter={buildingOptions.length > 8}
                            placeholder={intl.formatMessage({ id: 'Select' })}
                            className={defaultBuildingError ? 'p-invalid' : undefined}
                            onChange={(e) => setConfigData({
                                ...userConfigData,
                                defaultbuilding: buildingOptions.find(option => option.id === e.value) ?? null,
                            })}
                        />
                        {defaultBuildingError && <small className="p-error">{defaultBuildingError}</small>}
                    </div>
                </fieldset>
            )}
        </div>
    </React.Fragment>
}